import React from 'react';
import {
  Container,
  ContainerGutter,
  Text,
  TokenTextAppearance,
  TextTag
} from '@volkswagen-onehub/components-core';
import { getTranslations } from '../translations';
import PageHeaderWrapper from '../components/PageHeaderWrapper';

export const Header = () => {
  const { search_models: copy } = getTranslations();

  return (
    <PageHeaderWrapper>
      <Container
        gutter={ContainerGutter.static200}
      >
        <Text
          tag={TextTag.h2}
          appearance={TokenTextAppearance.headline500}
        >
          { copy.header[0] } <Text bold> { copy.header[1] } </Text>
        </Text>
      </Container>

      <Text
        tag={TextTag.p}
        appearance={TokenTextAppearance.copy200}
      >
        { copy.subhead }
      </Text>
    </PageHeaderWrapper>
  );
};
